.dashboard-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    width: 100%;
    background-color: var(--off-white);
}
